import Component from "vue-class-component";
import { VueBase } from "../../Controls/VueBase";
import { EventBus } from "../../Controls/EventBus";
import EventConstants from "../../Controls/EventConstants";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { AmorcageContratTauxPASDto } from "../../../dto/GenApi.iNotPaie.Dto/AmorcageContratTauxPASDto";
import { DsnNatureDeclaration } from "../../../dto/GenApi.iNotPaie.Dto/DsnNatureDeclaration";
import { ParametresInstance } from "../../Controls/Parameters";
import ModalVisualisationDetailsDsnComponent from "../modalVisualisationDetailsDsn/modalVisualisationDetailsDsn";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ColorServiceInstance } from "../../../shared/services/color.service";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import ModalCompteRenduDsnComponent from "../modalCompteRenduDsn/modalCompteRenduDsn";
import * as $ from "jquery";

@Component({
	components: {
		ModalVisualisationDetailsDsnComponent: require("../modalVisualisationDetailsDsn/modalVisualisationDetailsDsn.vue.html"),
		ModalCompteRenduDsnComponent: require("../modalCompteRenduDsn/modalCompteRenduDsn.vue.html")
	}
})
export default class tableAmorcageTauxPAS extends VueBase {
	public modalCompteRenduDsnComponent?: ModalCompteRenduDsnComponent = undefined;
	public modalVisualisationDetailsDsnComponent?: ModalVisualisationDetailsDsnComponent = undefined;
	private colorService = ColorServiceInstance;

	public listYears: number[] = [];

	public selectedYear: number | undefined = undefined;

	public dataReady = false;

	public listAmorcages: AmorcageContratTauxPASDto[] = [];

	// Variables de tri des colonnes.
	public curentOrderColumn = "DateDebutContrat";
	public orderingDesc = true;

	public mounted(): void {
		// Abonnement à l'événements de rafraichissement des données du module
		EventBus.$on(EventConstants.DSN_REFRESH_MODULE_AMORCAGE_TAUX_PAS, this.fetchDataFilter);
		// Abonnement à l'événements de rafraichissement des données d'amorçage du filtre en cours
		EventBus.$on(EventConstants.DSN_REFRESH_CURRENT_LIST_AMORCAGE_TAUX_PAS, this.fetchDataAmorcage);
		// Abonnement à l'événements de rafraichissement des données de filtre
		EventBus.$on(EventConstants.DSN_SELECTED_YEAR_CHANGE_AMORCAGE_TAUX_PAS, this.onSelectedYearChange);

		this.fetchDataFilter();
	}

	// Permet de faire un dépôt de la DSN manuellement ou de demander l'ouverture de la popup d'édition
	public demandeDepotDsn(item: AmorcageContratTauxPASDto, estManu: boolean): void {
		if (estManu) {
			this.ouverturePopupEditionDsnAmorcage(item);
		} else {
			this.faireDepot(item);
		}
	}

	// Récupère les données des amorçages de taux PAS
	private fetchDataAmorcage(): void {
		this.dataReady = false;
		this.listAmorcages = [];
		if (this.selectedYear) {
			ServicesFactoryInstance.AmorcageTauxPASService.GetAmorcagesContratsTauxPAS(this.selectedYear, (data) => {
				this.listAmorcages = data;

				this.dataReady = true;
			}, () => {
				this.dataReady = true;
			});
		} else {
			this.dataReady = true;
		}
	}

	// Récupère les données pour le filtre
	private fetchDataFilter(): void {
		this.dataReady = false;
		this.listYears = [];
		ServicesFactoryInstance.DsnService.getFirstDsnYear(DsnNatureDeclaration.AMORCAGETAUXPAS, (data) => {
			const currentExerciceYear: number = ParametresInstance.societeCourante?.PeriodeActive ? ParametresInstance.societeCourante?.PeriodeActive.getFullYear() : new Date().getFullYear();
			if (data) {
				//Dans le cas où l'exxercice est en retard sur l'année en cours
				const currentYear = new Date().getFullYear();
				const minValue: number = Math.min(data, currentExerciceYear, currentYear);
				const maxValue: number = Math.max(data, currentExerciceYear, currentYear);
				for (let i = minValue; i <= maxValue; i++) {
					this.listYears.push(i);
				}
			} else {
				this.listYears.push(currentExerciceYear);
			}

			if (this.selectedYear == undefined && this.listYears) {
				this.selectedYear = this.listYears[this.listYears.length - 1];
				this.$emit("selectedYear", this.selectedYear);
			}

			this.$emit("listYears", this.listYears);

			this.fetchDataAmorcage();
		}, () => {
			this.dataReady = true;
		});
	}

	// Récupère les données pour le filtre et applique le filtre
	private onSelectedYearChange(year: number | undefined): void {
		this.selectedYear = year;
		this.fetchDataAmorcage();
	}

	public visualiser(amorcage: AmorcageContratTauxPASDto): void {
		this.modalVisualisationDetailsDsnComponent = this.$refs.modalVisualisationDetailsDsnComponent as ModalVisualisationDetailsDsnComponent;

		this.modalVisualisationDetailsDsnComponent.Init(amorcage.Id);
		$("#modalVisualisationDetailsDsnComponent").modal("show");
	}

	public demandeConfirmationSuppressionDsnAmorcage(amorcage: AmorcageContratTauxPASDto): void {
		if (!amorcage) {
			return;
		}

		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: `Salarié n°${amorcage.NumeroSalarie} ${amorcage.NomSalarie} ${amorcage.PrenomSalarie} (contrat n°${amorcage.NumeroContrat})<BR><BR>Voulez-vous vraiment supprimer la DSN d'amorçage ?`,
			callBackYes: () => {
				this.supprimerDsnAmorcage(amorcage);
			},
			callBackNo: () => {}
		});

		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	// Détermine l'affichage des flèches de tri.
	public getClassOfOrder(columnName: string, desc: boolean): string {
		if (columnName == this.curentOrderColumn && this.orderingDesc == desc) {
			return "active";
		}

		return "";
	}

	// Prépare les paramètres de tri et effectue le tri sur une colonne dont le nom est passé en paramètre.
	public orderBy(columnName: string): void {
		if (this.curentOrderColumn == columnName) {
			this.orderingDesc = !this.orderingDesc;
		} else {
			this.orderingDesc = true;
		}
		this.curentOrderColumn = columnName;
		this.doOrder(columnName);
	}

	// Effectue le tri sur une colonne dont le nom est passé en paramètre.
	public doOrder(columnName: string): void {
		if (this.listAmorcages != undefined) {
			this.listAmorcages = this.listAmorcages.sort((a, b) => this.setSort(a, b, columnName));
		}
	}

	// Détermine l'ordre d'apparition entre 2 élements d'après le paramétrage de tri défini et une colonne donnée.
	public setSort(a: AmorcageContratTauxPASDto, b: AmorcageContratTauxPASDto, columnName: string): number {
		if (a[columnName] < b[columnName]) {
			return (this.orderingDesc ? -1 : 1);
		}
		if (a[columnName] > b[columnName]) {
			return (this.orderingDesc ? 1 : -1);
		}
		if (a[columnName] === b[columnName] && columnName === "NomSalarie") {
			return this.setSort(a, b, "PrenomSalarie");
		}

		return 0;
	}

	// Supprimer une DSN d'amorçage.
	private supprimerDsnAmorcage(amorcage: AmorcageContratTauxPASDto): void {
		if (!amorcage) {
			return;
		}

		this.dataReady = false;
		ServicesFactoryInstance.DsnService.supprimerDsnMetadata(amorcage.Id, () => {
			NotificationServiceInstance.SendSuccess("La suppression de la DSN d'amorçage s'est correctement déroulée !");
			this.fetchDataAmorcage();
			this.dataReady = true;
		}, () => {
			this.dataReady = true;
		});
	}

	private isEnvoiDsnAmorcageDisabled(item: AmorcageContratTauxPASDto): boolean {
		// Blocage de l'envoi si un retour est déjà conforme ou si un envoi est OK mais sans avoir encore reçu la conformité.
		if (!item ||
			item.EtatConformite === "OK" ||
			(item.EtatEnvoi === "OK" && !item.EtatConformite)) {
			return true;
		}

		return false;
	}

	// Ouvre la popup d'édition de la DSN
    private ouverturePopupEditionDsnAmorcage(item: AmorcageContratTauxPASDto): void {
        this.$emit("ouverturePopupEditionDsnAmorcage", item.Id, false, DsnNatureDeclaration.AMORCAGETAUXPAS);
	}

	// Fait un dépôt automatique de la DSN
	private faireDepot(item: AmorcageContratTauxPASDto): void {
		this.dataReady = false;
		const idDsnMetadata = item.Id;

		ServicesFactoryInstance.DsnService.envoyerDepot(idDsnMetadata, false, () => {
			NotificationServiceInstance.SendSuccess("L'envoi de la DSN a bien été effectuée.");
			this.fetchDataAmorcage();
		}, () => {
			this.dataReady = true;
		});
	}

	// Lance une actualisation des retours auprès de NetEntreprise et affiche le compte-rendu.
	public getCompteRendu(item: AmorcageContratTauxPASDto): void {
		if (!item) {
			return;
		}

		this.dataReady = false;

		ServicesFactoryInstance.DsnService.rafraichir(item.Id, data => {
			this.dataReady = true;

			// L'échec de récupération d'un flux de retour est non bloquant : il n'empêche pas
			// l'exploitation des autres retours du dépôt (le service poursuit sa boucle).
			// On le signale donc en avertissement, sans priver l'utilisateur du compte rendu.
			if (data.Erreurs != undefined && data.Erreurs.length > 0) {
				NotificationServiceInstance.SendWarningList(data.Erreurs);
			}

			this.modalCompteRenduDsnComponent = this.$refs.modalCompteRenduDsnComponent as ModalCompteRenduDsnComponent;

			this.modalCompteRenduDsnComponent.Init(item.Id);
			$("#modalCompteRenduDsnComponent").modal("show");
		}, () => this.dataReady = true);
	}

	public openSalarie(idSalarie: number, fullName: string): void {
		EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: fullName } });
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/tableAmorcageTauxPAS/tableAmorcageTauxPAS.ts